(function() {
    'use strict';

    angular
        .module('valueconnectApp')
        .factory('DeclinedSearch', DeclinedSearch);

    DeclinedSearch.$inject = ['$resource'];

    function DeclinedSearch($resource) {
        var resourceUrl =  'api/_search/declineds/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();
